import { useState, useEffect, useContext } from "react";
import { loadingActive, SplitScreenBackground } from "../components/Background";
import NavBar from "../components/NavBar";
import { useNavigate } from "react-router-dom";
import { requestLogin } from "../requests/users_requests";
import { AccountContext } from "../contexts/AccountContexts";
import { PageHeader } from "../components/HeaderComponents";
import { useTranslation } from "react-i18next";
import { TurnstileComponent } from "../components/CaptchaComponents";



function LoginPage() {
    const { t } = useTranslation('common')
    const { user, setIsTempUser, onLogout, getUserFromIdToken, checkSession } = useContext(AccountContext)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const navigator = useNavigate();
    const [invalid, setInvalid] = useState(false);
    const [errorMessage, setErrorMessage] = useState("")
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)

    const [captchaToken, setCaptchaToken] = useState(null)
    const [resetCaptcha, setResetCaptcha] = useState(false)

    useEffect(() => {
        // const accessToken = getAccessToken()
        // if (accessToken) {
        //     navigator('/admin/dashboard')
        // }
        checkSession().then((isSession) => {
            if (isSession) {
                if (isSession.user_type === "user") {
                    navigator('/member/home')
                }
                else {
                    navigator('/admin/dashboard')
                }
            }
        })

    }, [])

    useEffect(() => {
        if (errorMessage !== "" || success) {
            setErrorMessage("")
            setSuccess(false)
        }
    }, [email, password])

    const handleRedirect = (userData) => {
        if (userData?.class === "user") {
            const predefinedUrl = "/member/home";
            window.location.href = predefinedUrl;
        }
        else {
            const predefinedUrl = "/admin/dashboard";
            window.location.href = predefinedUrl;
        }
    };

    useEffect(() => {
        if (captchaToken) {
            setResetCaptcha(false)
        }
    }, [captchaToken])

    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        loadingActive(true)

        requestLogin({ email: email, password: password, captchaToken: captchaToken })
            .then((result) => {
                // setAccessToken(result.data.access_token)
                // setIdToken(result.data.id_token)
                setSuccess(true)

                console.info("Login successful. Redirecting to dashboard.")
                // onLogin(tkn.access_token.access_token, tkn.id_token)
                let userData = getUserFromIdToken(result.data.id_token)
                setLoading(false)
                loadingActive(false)
                setIsTempUser(false)
                handleRedirect(userData)
            })
            .catch((error) => {
                if (error.status === 409) {
                    // navigator("/admin/dashboard")
                    handleRedirect()
                }
                setResetCaptcha(true)
                setErrorMessage(error.message)
                setLoading(false)
                loadingActive(false)
            })
    }


    return <>
        <SplitScreenBackground />
        <div className="flex flex-col items-center py-2  gap-5 pb-10">
            <PageHeader pageTitle={t("Sign In")} />
            <NavBar />
            <main className="absolute top-0 bottom-0 flex flex-wrap justify-center items-center w-full mx-auto max-w-[1200px] z-0 p-1 sm:p-5 gap-4">
                <form
                    className="flex flex-col min-w-64 w-96 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 shadow-sm rounded-xl py-5 px-3 gap-1"
                    onSubmit={handleSubmit}
                >
                    <h1 className="font-semibold text-2xl px-2">{t("Sign in")}</h1>

                    {
                        success &&
                        <span className="text-green-700 px-2">{t('Signed in successfully. Redirecting...')}</span>
                    }

                    <div className="flex w-full px-2">
                        <label className="form-control w-full">
                            <div className="label">
                                <span className="label-text text-base text-gray-800 dark:text-gray-300 font-semibold">
                                    {t('E-mail')}
                                </span>
                            </div>
                            <input
                                type="email"
                                required={true}
                                autoFocus={true}
                                placeholder={t("Enter e-mail")}
                                className="input input-bordered invalid:border-red-600 input-md w-full h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                }}
                            />
                        </label>
                    </div>

                    <div className="flex w-full px-2">
                        <label className="form-control w-full">
                            <div className="label">
                                <span className="label-text text-base text-gray-800 dark:text-gray-300 font-semibold">
                                    {t('Password')}
                                </span>
                            </div>
                            <input
                                type="password"
                                required={true}
                                placeholder={"*****"}
                                className="input input-bordered input-md w-full h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                }}
                            />
                        </label>
                    </div>


                    <div className="hidden gap-2 w-full justify-center items-center pt-3">
                        <button type="button" className="btn btn-sm">Register</button>
                        <button type="button" className="btn btn-sm">Forgot Password</button>
                    </div>

                    {
                        errorMessage !== "" &&
                        <span className="text-red-600 dark:text-red-500 px-2 text-center">{errorMessage}</span>
                    }
                    <div className="flex w-full justify-center mt-3">
                        <TurnstileComponent getToken={setCaptchaToken} reset={resetCaptcha} />
                    </div>

                    <button
                        type="submit"
                        disabled={loading || success}
                        className="btn bg-primary hover:bg-primary/90 border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 text-white font-semibold mx-[6px] mt-3"
                    >
                        {t('Login')}
                    </button>
                </form>
            </main>
        </div>
    </>
}


export default LoginPage;